import Button from 'components/ui/button';
import { useAuth } from 'context/AuthContext';
import { useCallback, useEffect, useState } from 'react';
import { IoIosClose } from 'react-icons/io';
import { getNews, getNewsLog, updateNewLog } from 'services/news.service';
import { updateUserProfile } from 'services/profile.service';

import './styles.scss';
import { UserInfo } from 'types/user';

interface Props {
  send: () => void;
  player: UserInfo | null | undefined;
}

export default function NewFeatures(data: Props) {
  const { send, player } = data;
  const [news, setNews] = useState<any>();
  const [didInit, setDidInit] = useState(false);
  const [loading, setLoading] = useState(false);

  const { user } = useAuth();

  const loadNews = useCallback(async () => {
    if (loading || !user || !player) return;

    setLoading(true);
    setDidInit(true);

    try {
      const log = await getNewsLog();
      const data = await getNews(player.cad_missao, log?.time);

      if (data) {
        setNews(data);
      } else {
        send();
      }
    } finally {
      setLoading(false);
    }
  }, [loading, player, send, user]);

  const handleCloseTutorial = useCallback(async () => {
    if (!user) return;
    setNews(undefined);

    await updateNewLog(user?._id, news?.created);

    loadNews();
  }, [loadNews, news?.created, user]);

  useEffect(() => {
    if (didInit) return;

    loadNews();
  }, [didInit, loadNews]);

  useEffect(() => {
    window.addEventListener('close-news', handleCloseTutorial);
    return () => {
      window.removeEventListener('close-news', handleCloseTutorial);
    };
  }, [handleCloseTutorial]);

  if (!news) return null;

  return (
    <div className="z-50 modal-news fixed bg-black bg-opacity-40 top-0 left-0 w-screen h-screen p-6 pt-[10vh] flex justify-center overflow-y-auto">
      <div className="relative border-2 border-solid border-electric-blue bg-oxford-blue rounded-lg p-10 max-w-[600px] h-fit">
        <Button
          color="primary"
          className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center z-50"
          onClick={() => handleCloseTutorial()}
        >
          <IoIosClose color="white" size={30} />
        </Button>

        {news?.text && <div dangerouslySetInnerHTML={{ __html: news.text }}></div>}
      </div>
    </div>
  );
}
